export default __webpack_public_path__ + "static/media/medical-insurance.114500b6.png";